import { getApiClient } from '@src/services/api-client'
import { MutationFunction, useMutation } from '@tanstack/react-query'
import { makeGetCsv } from '../make-api'

const newsletterSubscriptionExportApi = makeGetCsv('/NewsletterSubscription/export')

async function downloadNewsletterSubscriptionsExport() {
  const apiClient = getApiClient()
  return newsletterSubscriptionExportApi(apiClient)
}

export function useNewsletterSubscriptionsExport(): [MutationFunction<void, void>, boolean] {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: downloadNewsletterSubscriptionsExport,
  })

  return [mutateAsync, isPending]
}
